export function trackEvent (logRocket, name, data = {}) {
  console.info(`[telemetry] ${name}`, data)

  if (process.env.APP_ENV !== 'production' || typeof logRocket?.track !== 'function') {
    return
  }

  try {
    logRocket.track(name, data)
  } catch (error) {
    console.warn(`[telemetry] failed to track ${name}`, error)
  }
}
